"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSchemaCollection = exports.processSimplifiedSchema = exports.transformAtValue = void 0;
var lodash_1 = require("lodash");
/**
 * Transforms string values starting with @ into appropriate action objects
 * @param value Any value to check for transformation
 * @returns Action object or undefined if no transformation needed
 */
var transformAtValue = function (value) {
    if (typeof value === 'string' && value.startsWith('@')) {
        var parts = value.slice(1).split('.');
        var source = parts[0], rest = parts.slice(1);
        var location_1 = rest.join('.');
        if (source === 'localStorage') {
            return {
                action: 'getValueFromLocalStorage',
                args: { storedLocation: location_1 },
            };
        }
        else if (source === 'event') {
            return { type: 'event', action: 'getValueFromEvent', args: { location: location_1 } };
        }
        else if (source === 'state') {
            return {
                type: 'redux',
                action: 'getState',
                args: { storedLocation: location_1 },
            };
        }
        else if (source === 'location') {
            var _a = location_1.split('^'), key = _a[0], pattern = _a[1];
            return {
                action: 'getValueFromLocation',
                args: { key: key, pattern: pattern },
            };
        }
        else if (source === 'constants') {
            return {
                action: 'getConstantValue',
                args: { key: location_1 },
            };
        }
    }
    return undefined;
};
exports.transformAtValue = transformAtValue;
/**
 * Process a simplified schema by applying styles, handlers, and effects
 * @param schema The schema object to process
 * @returns The processed schema
 */
var processSimplifiedSchema = function (schema) {
    // Process styles
    if (schema.styles) {
        if (schema.name && schema.styles[schema.name]) {
            Object.assign(schema, schema.styles[schema.name]);
        }
        var applyStyles_1 = function (field) {
            if (!field.name)
                return field;
            // Apply styles from central styles object if they exist
            if (schema.styles && schema.styles[field.name]) {
                Object.assign(field, schema.styles[field.name]);
            }
            // Recursively process child fields
            if (field.fields) {
                field.fields = field.fields.map(applyStyles_1);
            }
            // Process renderers if present
            if (field.renderers) {
                field.renderers = field.renderers.map(applyStyles_1);
            }
            // Process thead items with renderers
            if (field.thead) {
                field.thead = field.thead.map(function (theadItem) {
                    if (theadItem.renderers) {
                        theadItem.renderers = theadItem.renderers.map(applyStyles_1);
                    }
                    return theadItem;
                });
            }
            return field;
        };
        // Start processing from top-level fields
        if (schema.fields) {
            schema.fields = schema.fields.map(applyStyles_1);
        }
    }
    // Process handlers
    if (schema.handlers) {
        var applyHandlers_1 = function (field) {
            if (!field.name)
                return field;
            // Apply handlers from central handlers object
            if (schema.handlers && schema.handlers[field.name]) {
                field.handlers = schema.handlers[field.name];
            }
            // Special case for popconfirm.onConfirm
            if (field.element === 'popconfirm' &&
                schema.handlers['popconfirm.onConfirm']) {
                field.onConfirm = schema.handlers['popconfirm.onConfirm'];
            }
            // Recursively process child fields
            if (field.fields) {
                field.fields = field.fields.map(applyHandlers_1);
            }
            // Process renderers if present
            if (field.renderers) {
                field.renderers = field.renderers.map(applyHandlers_1);
            }
            // Process thead items with renderers
            if (field.thead) {
                field.thead = field.thead.map(function (theadItem) {
                    if (theadItem.renderers) {
                        theadItem.renderers = theadItem.renderers.map(applyHandlers_1);
                    }
                    return theadItem;
                });
            }
            return field;
        };
        // Start processing from top-level fields
        if (schema.fields) {
            schema.fields = schema.fields.map(applyHandlers_1);
        }
    }
    // Process effects field
    if (schema.effects && schema.fields) {
        // Find the effects field or create it if it doesn't exist
        var effectsField = schema.fields.find(function (field) { return field.name === 'effects'; });
        if (!effectsField) {
            effectsField = { name: 'effects', handlers: [] };
            schema.fields.push(effectsField);
        }
        // Set the handlers on the effects field
        effectsField.handlers = schema.effects;
    }
    // Apply transformers to handle @ directives
    var transformedSchema = (0, lodash_1.cloneDeepWith)(schema, function (value) {
        return (0, exports.transformAtValue)(value); // if undefined, cloneDeepWith will continue
    });
    return transformedSchema;
};
exports.processSimplifiedSchema = processSimplifiedSchema;
/**
 * Process a collection of schema items by checking each to see if it needs
 * to be processed with processSimplifiedSchema
 * @param schemaItems Array of schema items
 * @returns Processed schema items
 */
var processSchemaCollection = function (schema) {
    var processedSchema = null;
    var schemaItem = schema.schema[0];
    // Check if this is a simplified schema by looking for styles/handlers at top level
    // if (schemaItem.styles || schemaItem.handlers || schemaItem.effects) {
    processedSchema = (0, exports.processSimplifiedSchema)(schemaItem);
    schema.schema[0] = processedSchema;
    // }
    // console.log('>Simplified schema', schema);
    return schema;
};
exports.processSchemaCollection = processSchemaCollection;
